import {makeAutoObservable, runInAction} from 'mobx'
import config, {systemObjects} from 'src/config'
import {MainStore} from 'src/store/MainStore'
import UnapprovedReportSummary from 'src/entities/UnapprovedReportSummary'
import CodeObject from 'src/entities/CodeObject'

export class UnapprovedReportsStore {
  summaries: UnapprovedReportSummary[] = []

  isLoading: boolean = false

  // Code tables needed for the chips: report status (CT 7) + per-row import errors (CT 11).
  studentReportStatuses: CodeObject[] = []

  studentImportStatuses: CodeObject[] = []

  constructor(readonly owner: MainStore) {
    makeAutoObservable(this)
  }

  getUnapprovedSummaries = () => {
    runInAction(() => {
      this.isLoading = true
    })
    this.owner.loginStore
      .fetchWithUser(`${config.apiUrl}/StudentReports/unapproved-summary`)
      .then((res: any) => res.json())
      .then((data: any[]) => {
        runInAction(() => {
          this.summaries = (data ?? []).map(
            (d: any) => new UnapprovedReportSummary(d)
          )
          this.isLoading = false
        })
      })
      .catch((e: any) => {
        console.log('error:', e)
        runInAction(() => {
          this.isLoading = false
        })
      })
  }

  getStudentReportStatuses = () => {
    this.owner.loginStore
      .fetchWithUser(
        `${config.apiUrl}/CodeTables/${systemObjects.studentReportStatuses}`
      )
      .then((res: any) => res.json())
      .then((data: any) => {
        if (data) {
          runInAction(() => {
            this.studentReportStatuses = data.map((i: any) => new CodeObject(i))
          })
        }
      })
      .catch((e: any) => console.log('error:', e))
  }

  getStudentImportStatuses = () => {
    this.owner.loginStore
      .fetchWithUser(
        `${config.apiUrl}/CodeTables/${systemObjects.studentImportStatuses}`
      )
      .then((res: any) => res.json())
      .then((data: any) => {
        if (data) {
          runInAction(() => {
            this.studentImportStatuses = data.map((i: any) => new CodeObject(i))
          })
        }
      })
      .catch((e: any) => console.log('error:', e))
  }

  loadCodeTables = () => {
    if (this.studentReportStatuses.length === 0) this.getStudentReportStatuses()
    if (this.studentImportStatuses.length === 0) this.getStudentImportStatuses()
  }
}
